import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import SearchObject from './SearchObject';
import Parameter from './Parameter';

var ExpressionNode = /*#__PURE__*/function () {
  function ExpressionNode(expressionNode) {
    if (expressionNode) {
      this._searchObject = new SearchObject(expressionNode.searchObject);
      this._children = expressionNode.children ? expressionNode.children.map(function (child) {
        return new ExpressionNode(child);
      }) : null;
      this._type = expressionNode.type;
      this._id = expressionNode.id;
      this._function = expressionNode['function'];
      this._parameters = expressionNode.parameters ? expressionNode.parameters.map(function (param) {
        return new Parameter(param);
      }) : null;
    }
  }

  var _proto = ExpressionNode.prototype;

  _proto.getExpressionNodeObjectification = function getExpressionNodeObjectification() {
    var ret = {};

    if (this._searchObject) {
      ret.searchObject = this._searchObject.getSearchObjectObjectification();
    }

    if (this._children) {
      if (this._children.length === 0) {
        ret.children = [];
      } else {
        ret.children = this._children.map(function (ch) {
          return ch.getExpressionNodeObjectification();
        });
      }
    }

    if (this._type) {
      ret.type = this._type;
    }

    if (this._id) {
      ret.id = this._id;
    }

    if (this._function) {
      ret['function'] = this._function;
    }

    if (this._parameters) {
      if (this._parameters.length === 0) {
        ret.parameters = [];
      } else {
        ret.parameters = this._parameters.map(function (param) {
          return param.getParameterObjectification();
        });
      }
    }

    return ret;
  };

  _createClass(ExpressionNode, [{
    key: 'searchObject',
    get: function get() {
      return this._searchObject;
    }
  }, {
    key: 'children',
    get: function get() {
      return this._children;
    }
  }, {
    key: 'type',
    get: function get() {
      return this._type;
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'function',
    get: function get() {
      return this._function;
    }
  }, {
    key: 'parameters',
    get: function get() {
      return this._parameters;
    }
  }]);

  return ExpressionNode;
}();

export { ExpressionNode as default };